// src/contexts/ConfirmationContext.jsx

import React, { createContext, useState, useContext } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';

const ConfirmationContext = createContext();

export const ConfirmationProvider = ({ children }) => {
    const [confirmationState, setConfirmationState] = useState({
        open: false,
        title: '',
        message: '',
        resolve: null,
        reject: null,
    });

    const confirm = (title, message) => {
        return new Promise((resolve, reject) => {
            setConfirmationState({
                open: true,
                title,
                message,
                resolve,
                reject,
            });
        });
    };

    const handleClose = (result) => {
        if (result) {
            confirmationState.resolve(true);
        } else {
            confirmationState.resolve(false);
        }
        setConfirmationState({
            ...confirmationState,
            open: false,
            title: '',
            message: '',
            resolve: null,
            reject: null,
        });
    };

    return (
        <ConfirmationContext.Provider value={{ confirm }}>
            {children}
            <Dialog
                open={confirmationState.open}
                onClose={() => handleClose(false)}
                aria-labelledby="confirmation-dialog-title"
                aria-describedby="confirmation-dialog-description"
            >
                <DialogTitle id="confirmation-dialog-title">
                    {confirmationState.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirmation-dialog-description">
                        {confirmationState.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={() => handleClose(true)} color="primary" autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </ConfirmationContext.Provider>
    );
};

// Custom hook to use the confirmation context
export const useConfirm = () => {
    return useContext(ConfirmationContext).confirm;
};
